import type {SkillWithMatch, SkillMatchStatus} from '../components/profile-card/types';

export interface NormalizedSkill {
    value: string;
    status?: SkillMatchStatus;
    key: string;
}

export function normalizeSkills(skills: string[] | SkillWithMatch[]): NormalizedSkill[] {
    return skills.map((skill, index) => {
        if (typeof skill === 'object') {
            return {
                ...skill,
                key: `${skill.value}-${skill.status}-${index}`,
            };
        }
        return {
            value: skill,
            key: skill,
        };
    });
}
